// @LTG-ID: F-004
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 08_FEATURES.md#F-004, source Landing Page.html lines 1403-1418
// @CHANGED: 2026-02 session_002
// @OWNER: web

import "./trust-strip.css";

const ITEMS = [
    "Tax preparation",
    "IRS resolution",
    "Advisory",
    "Valuations",
    "Entity work",
];

export function TrustStrip() {
    return (
        <div className="ltg-trust" data-testid="trust-strip">
            <div className="ltg-container">
                <div
                    className="ltg-trust__count"
                    data-testid="truststrip-count"
                >
                    Trusted by 1200+ owner-operated businesses across the U.S.
                </div>
                <div className="ltg-trust__grid">
                    <div className="ltg-trust__label">
                        KGOB CPAs &amp; Advisors &middot; Charlotte NC
                    </div>
                    <div className="ltg-trust__items">
                        {ITEMS.map((label) => (
                            <span key={label}>
                                <i
                                    className="ltg-trust__swatch"
                                    aria-hidden="true"
                                />
                                {label}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TrustStrip;
